export default "__VITE_ASSET__C4IkC3M3__"